var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import request from 'superagent';
import { Alert, Button, Form, Spin } from 'antd';
/*
import Alert from 'antd/lib/alert';
import Button from 'antd/lib/button';
import Form from 'antd/lib/form';
import Spin from 'antd/lib/spin';
*/
import _ from 'lodash';

export { default as DimioModal } from './DimioModal';

// ----------------------------------------------------------------------------
// Base Parts
// ----------------------------------------------------------------------------
export var LoadingSpinner = function LoadingSpinner(props) {
  return props.processing ? React.createElement(
    'div',
    { className: 'dimio-loader' },
    React.createElement(Spin, { size: 'large', tip: 'processing', className: 'd-flex justify-content-center align-items-center' })
  ) : null;
};

export var ErrorMessage = function ErrorMessage(props) {
  return React.createElement(
    'div',
    { className: 'dimio-error' },
    props.message && React.createElement(Alert, { message: props.message, type: 'error' })
  );
};

/**
 * Usage
 *
 * <DimioNotice {...core} />
 *
 * @param props
 *   processing: bool
 *   message: Message
 * @returns {*}
 * @constructor
 */
export var DimioNotice = function DimioNotice(props) {
  return React.createElement(
    'div',
    null,
    React.createElement(LoadingSpinner, props),
    props.message && props.message.type == 'error' && React.createElement(ErrorMessage, props)
  );
};

// ----------------------------------------------------------------------------
// Component
// ----------------------------------------------------------------------------
/**
 *
 */
export var DimioComponent = function (_Component) {
  _inherits(DimioComponent, _Component);

  function DimioComponent() {
    _classCallCheck(this, DimioComponent);

    return _possibleConstructorReturn(this, (DimioComponent.__proto__ || Object.getPrototypeOf(DimioComponent)).apply(this, arguments));
  }

  _createClass(DimioComponent, [{
    key: 't',

    /*
    constructor(props) {
      super(props);
    }
    */

    /**
     * extends DimioComponent
     *
     * access: this.t('key');
     * if it's const access by core.trans.get(label)
     *
     *
     * @param label
     * @returns {*}
     */
    value: function t(label) {
      var core = this.props.core;

      if (_.has(core, 'trans.get')) {
        return core.trans.get(label);
      } else {
        return label;
      }

      //return (core.trans)?core.trans.get(label):label;
    }
  }, {
    key: 'showLoading',


    //-----------------------------------------------------------
    // Loading
    //-----------------------------------------------------------
    value: function showLoading() {
      var dispatch = this.props.dispatch;

      dispatch({
        type: 'core/processing',
        processing: true
      });
    }
  }, {
    key: 'hideLoading',
    value: function hideLoading() {
      var dispatch = this.props.dispatch;

      dispatch({
        type: 'core/processing',
        processing: false
      });
    }

    //-----------------------------------------------------------
    // Page
    //-----------------------------------------------------------

  }, {
    key: 'changePage',
    value: function changePage(page) {
      var dispatch = this.props.dispatch;

      dispatch({
        type: 'core/changePage',
        page: page
      });
    }

    //-----------------------------------------------------------
    // Message
    //-----------------------------------------------------------
    /*
    showSuccess(message){
      const {dispatch} = this.props;
      dispatch({
        type: 'meta/showSuccess',
        success: message
      });
    }
    */

  }, {
    key: 'showError',
    value: function showError(error) {
      var dispatch = this.props.dispatch;

      dispatch({
        type: 'core/message',
        error: error
      });
    }
  }, {
    key: 'hideError',
    value: function hideError() {
      var dispatch = this.props.dispatch;

      dispatch({
        type: 'core/message',
        error: false
      });
    }
  }]);

  return DimioComponent;
}(Component);

/**
 *
 */
export var FormComponent = function (_DimioComponent) {
  _inherits(FormComponent, _DimioComponent);

  function FormComponent() {
    var _ref;

    var _temp, _this2, _ret;

    _classCallCheck(this, FormComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = FormComponent.__proto__ || Object.getPrototypeOf(FormComponent)).call.apply(_ref, [this].concat(args))), _this2), _this2.Field = function (props) {
      var core = _this2.props.core;
      var getFieldDecorator = _this2.props.form.getFieldDecorator;

      var label = core && core.trans ? _this2.t(props.label) : props.label;

      // [TODO]
      // debugger;
      return React.createElement(
        Form.Item,
        Object.assign({}, props, {
          label: label
        }),
        getFieldDecorator(props.name, props.options)(React.Children.only(props.children))
      );
    }, _this2.Submit = function (props) {
      return React.createElement(
        Form.Item,
        props,
        React.createElement(
          Button,
          {
            type: 'primary',
            htmlType: 'submit',
            className: props.className ? props.className : null,
            disabled: props.disabled ? props.disabled : false
          },
          props.children
        )
      );
    }, _temp), _possibleConstructorReturn(_this2, _ret);
  }
  /*
  constructor(props) {
    super(props);
  }
  */
  /*
    shouldComponentUpdate(nextProps, nextState) {
      debugger;
      const propsDiff = _.isEqual(nextProps, this.props);
      const stateDiff = _.isEqual(nextState, this.state);
      return !(propsDiff && stateDiff);
    }
  */

  return FormComponent;
}(DimioComponent);

// ----------------------------------------------------------------------------
// Dimio
// ----------------------------------------------------------------------------
/**
 * props
 *
 * call the library in componentWillMount()
 *
 * componentWillMount() {
 *   this.dimio = new Dimio(this);
 * }
 */

var Dimio = function () {
  function Dimio(_ref2) {
    var props = _ref2.props;

    _classCallCheck(this, Dimio);

    //    console.info('Dimio', props);
    this.props = props;
    //    this.key   = props.opt.model;
    //    this.key   = props.core.model;
  }

  _createClass(Dimio, [{
    key: 'test',
    value: function test() {
      console.info(this.props);
    }

    /*
    apiError(error, options){
      if(error.status === 500){
        message.error('問題が発生しました');
        // send auto message
      }else {
        if (options.onError) {
          options.onError((error.response)?error.response.body:error);
        }else{
    //        message((error.response)?error.response.body:error);
        }
      }
      console.error((error.response)?error.response.body:error);
    };
    */
    //-----------------------------------------------------------
    // Form
    //-----------------------------------------------------------
    /**
     * DO NOT REMOVE this pattern is useful
     * this needs to be static method or call in WillComponent
    createField(){
        const { getFieldDecorator } = this.props.form;
         const Field = (props) => {
          return (
            <Form.Item
              {...props}
              label={props.label}
            >
              {getFieldDecorator(props.name, props.options)(
                React.Children.only(props.children)
              )}
            </Form.Item>
          );
        };
         return Field;
    };
     */

    //-----------------------------------------------------------
    // API
    //-----------------------------------------------------------
    /**
     * @param url
     * @param query
     * @returns request:Promise
     */

  }], [{
    key: 'load',
    value: function load(url, query) {
      var opt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { checkSuccess: true };

      if (url === undefined || url == '') {
        throw 'url is not set';
      }

      console.info('[LOAD: ' + url + '] ', query);
      return request.get(url).query(query).type('json').then(function (res) {
        console.info(res.body);
        if (opt) {
          if (opt.checkSuccess) {
            if (!res.body.success) {
              return Promise.reject(res.body.error);
            }
          }
        }
        return res.body;
      }).catch(function (err) {
        return Promise.reject(err);
      });
    }
  }, {
    key: 'save',
    value: function save(url, query) {
      var opt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { checkSuccess: true };

      console.info('[SAVE: ' + url + '] ', query);
      var req = request.post(url).send(query).type('form');

      if (opt) {
        if (opt.format == 'json') {
          req.set('Content-Type', 'application/json');
          req.set('Accept', 'application/json');
        }

        if (opt.token) {
          req.set('X-CSRF-TOKEN', opt.token);
        }

        if (opt.debug) {
          req.set('XDEBUG_SESSION_START', 1);
        }
      }

      return req.then(function (res) {
        console.info(res.body);
        if (opt) {
          if (opt.checkSuccess) {
            if (!res.body.success) {
              return Promise.reject(res.body.error);
            }
          }
        }
        return res.body;
      }).catch(function (err) {
        return Promise.reject(err);
      });

      return req;
    }
  }]);

  return Dimio;
}();

export default Dimio;

// ----------------------------------------------------------------------------
// Functions
// ----------------------------------------------------------------------------
/**
 * @structure
 *  [opt.model]: state[opt.model]
 * @param state
 * @param ownProps
 */
export var mapStateToProps = function mapStateToProps(state, ownProps) {
  //const {_cog} = ownProps;
  var core = state.core;


  var ret = { core: core };

  if (core.model) {
    ret[core.model] = state[core.model];
  }
  //  debugger;
  console.info(ret);
  return ret;
};

export var mapPropsToFields = function mapPropsToFields(items, map) {
  //const map = ['description'];
  var initValues = {};
  if (items) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = map[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var key = _step.value;

        if (items[key]) {
          initValues[key] = Form.createFormField({ value: items[key] });
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
  console.info('init', initValues);

  return initValues;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/dimio/dist/Dimio.js
// module id = 419
// module chunks = 0